import $ from 'jquery';
import { trackTrialDownloadStarted } from './analytics/marketing-events';

export function smartalbumsDownload () {
  if ($('#download_iframe').length > 0) {
    var redirectUrl = $('[target="download_iframe"]').attr('href');
    $('#download_iframe').attr('src', redirectUrl);
    trackTrialDownloadStarted('Auto iframe');
  }

  if (window.intervalIds) {
    window.intervalIds.forEach(clearInterval);
  }
  window.intervalIds = [];

  let timeOut = 500;

  // Hero animation
  $('.sa-download__hero').addClass('-animated');

  // Startup animations
  setTimeout(() => {
    setTimeout(() => {
      $('#circle-1').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 0);

    setTimeout(() => {
      $('#circle-2').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 100);

    setTimeout(() => {
      $('#circle-3').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 200);

    setTimeout(() => {
      $('#circle-4').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 300);

    setTimeout(() => {
      $('#circle-5').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 400);

    setTimeout(() => {
      $('.sa-download__hero').addClass('-stop-init-animation');
    }, 1000);
  }, timeOut);
}
